<template>
    <div>
        <h5>既往病史</h5>
        <div class="card">
            <div class="flex">
                <el-form-item label="严重皮肤病" label-width="130px">
                    <el-radio-group @change="testSX" v-model="formData.skinDisease">
                        <el-radio :label="'1'">有</el-radio>
                        <el-radio :label="'0'">无</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="糖尿病" label-width="130px">
                    <el-radio-group @change="testSX" v-model="formData.diabetes">
                        <el-radio :label="'1'">有</el-radio>
                        <el-radio :label="'0'">无</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="自身免疫性疾病" label-width="130px">
                    <el-radio-group @change="testSX" v-model="formData.autoimmuneDisease">
                        <el-radio :label="'1'">有</el-radio>
                        <el-radio :label="'0'">无</el-radio>
                    </el-radio-group>
                </el-form-item>
            </div>
            <div class="flex">
                <el-form-item label="凝血功能障碍" label-width="130px">
                    <el-radio-group @change="testSX" v-model="formData.coagulationDisorders">
                        <el-radio :label="'1'">有</el-radio>
                        <el-radio :label="'0'">无</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否在本院首次注射药物或者填充物" label-width="300px">
                    <el-radio-group @change="testSX" v-model="formData.isFirst">
                        <el-radio :label="'1'">有</el-radio>
                        <el-radio :label="'0'">无</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="药物/食物过敏史" label-width="200px">
                    <el-radio-group class="flex  flexRadio" @change="testSX" v-model="formData.allergyHistory">
                        <el-radio :label="'1'">有</el-radio>
                        <el-input class="double" v-model.trim="formData.allergy" placeholder="请输入"></el-input>
                        <el-radio :label="'0'">无</el-radio>
                    </el-radio-group>
                </el-form-item>
            </div>
            <div class="flex">
                <el-form-item label="是否月经期" label-width="130px">
                    <el-radio-group @change="testSX" v-model="formData.period">
                        <el-radio :label="'1'">有</el-radio>
                        <el-radio :label="'0'">无</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否怀孕" label-width="130px">
                    <el-radio-group @change="testSX" v-model="formData.pregnant">
                        <el-radio :label="'1'">有</el-radio>
                        <el-radio :label="'0'">无</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否哺乳期" label-width="130px">
                    <el-radio-group @change="testSX" v-model="formData.sucklingPeriod">
                        <el-radio :label="'1'">有</el-radio>
                        <el-radio :label="'0'">无</el-radio>
                    </el-radio-group>
                </el-form-item>
            </div>
        </div>
        <h5>初步诊断</h5>
        <div class="card">
            <el-form-item label="诊断" class="double">
                <el-checkbox-group @change="testSX" v-model="formData.injectionDiagnosisNo">
                    <el-checkbox v-for="(item,index) in injectDiagnosis" :key="index" :label="item.id">
                        <span>{{item.name}}</span>
                    </el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="其他" class="double">
                <el-input v-model.trim="formData.injectionDiagnosisOther" style="width:95%;" placeholder="请输入其他诊断"></el-input>
            </el-form-item>
        </div>
    </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { METHODS } from 'http';
export default {
    props: ['formData',],
    computed: {
        ...mapState(['diagnosis', 'injectDiagnosis']),
    },
    data() {
        return {

        }
    },
    methods: {
        testSX() {
            this.$forceUpdate()
        },
    }
}
</script>
<style scoped>
.card {
  background: #e0e6f0;
  border-radius: 10px;
  margin-bottom: 10px;
  padding-top: 5px;
  box-sizing: border-box;
}
.flex {
  display: flex;
  align-items: center;
}
.card >>> .el-form-item__label {
  line-height: 30px;
}
.double >>> .el-input__inner {
  height: 30px;
  line-height: 30px;
  font-size: 12px;
}
.flexRadio >>> .el-radio {
  margin-right: 5px !important;
}
</style>


